import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { notificationsEndpoints } from '@/modules/notifications/constants';

import { notificationsQueryKeys } from './queryKeys';

export const useNotificationsQuery = () => {
  return useQuery({
    queryKey: notificationsQueryKeys.list(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        notificationsEndpoints.notifications,
      );
      return data;
    },
  });
};
